import { Box, Flex, SparkleIcon, Typography } from '@iheartjane/reefer';
import type { ColorKey, IconColor, IconSize } from '@iheartjane/reefer';

export const MagicRowSubtitle = ({
  iconColor,
  iconSize = 'sm',
  textColor = 'gradient-primary',
}: {
  iconColor?: IconColor;
  iconSize?: IconSize;
  textColor?: ColorKey;
}) => {
  return (
    <Flex gap={4} alignItems="center">
      <Box>
        <SparkleIcon size={iconSize} color={iconColor} />
      </Box>
      <Typography color={textColor}>
        Curated recommendations tailored to your unique shopping habits
      </Typography>
    </Flex>
  );
};
